var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "landing", staticStyle: { "margin-buttom": "50px" } },
    [
      _vm.sectionPrincipal
        ? _c("div", { attrs: { id: "section-principal" } }, [
            _vm._m(0),
            _vm._m(1),
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "section-content" }, [
                _vm._m(2),
                _c("section", { staticClass: "menu" }, [
                  _c("div", { staticClass: "item-button menu-principal" }, [
                    _c(
                      "article",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToRegistro()
                          }
                        }
                      },
                      [_vm._m(3)]
                    ),
                    _c("h3", [_vm._v("Registra tu siniestro")])
                  ]),
                  _c("div", { staticClass: "item-button menu-principal" }, [
                    _c(
                      "article",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToConsulta()
                          }
                        }
                      },
                      [_vm._m(4)]
                    ),
                    _c("h3", [_vm._v("Estado de solicitud")])
                  ])
                ]),
                _vm.sectionCaptcha
                  ? _c("div", {
                      staticClass: "g-recaptcha",
                      staticStyle: { margin: "30px auto", width: "300px" },
                      attrs: { id: "g-recaptcha", "data-sitekey": _vm.siteKey }
                    })
                  : _vm._e()
              ])
            ]),
            _c("section", { staticStyle: { background: "#F5F5F5" } }, [
              _c("div", { staticClass: "container" }, [
                _c(
                  "section",
                  {
                    staticStyle: { display: "flex", "justify-content": "row" }
                  },
                  [
                    _c(
                      "v-flex",
                      {
                        staticClass: "only-desktop-flex",
                        attrs: {
                          xs12: "xs12",
                          sm12: "sm12",
                          md6: "md6",
                          lg6: "lg6"
                        }
                      },
                      [
                        _c("v-layout", [
                          _c("figure", { staticStyle: { margin: "auto" } }, [
                            _c("img", {
                              attrs: {
                                src: require("../assets/img/demo-smartphone.svg")
                              }
                            })
                          ])
                        ])
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      {
                        staticClass: "only-desktop-flex",
                        attrs: {
                          xs12: "xs12",
                          sm12: "sm12",
                          md6: "md6",
                          lg6: "lg6"
                        }
                      },
                      [
                        _c(
                          "v-layout",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column"
                            }
                          },
                          [
                            _c(
                              "h2",
                              {
                                staticStyle: {
                                  "font-weight": "400",
                                  "font-size": "36px !important",
                                  "line-height": "39px",
                                  "text-align": "left",
                                  color: "#0855C4",
                                  "margin-top": "30px"
                                }
                              },
                              [
                                _vm._v(
                                  "¿Deseas saber como registrar un siniestro?"
                                )
                              ]
                            ),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "padding-top": "20px",
                                  "padding-bottom": "20px",
                                  "text-align": "left"
                                }
                              },
                              [
                                _vm._v(
                                  "Aquí podrás descargar el manual de los pasos, con la información necesaria."
                                )
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass:
                                  "btn-solicitud btn-pink-filled omnesMedium",
                                staticStyle: {
                                  margin: "0",
                                  height: "50px",
                                  width: "220px"
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadManual()
                                  }
                                }
                              },
                              [_vm._v("Descargar manual")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { staticClass: "only-mobile-flex" },
                      [
                        _c(
                          "v-layout",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column",
                              "margin-bottom": "40px"
                            }
                          },
                          [
                            _c(
                              "h2",
                              {
                                staticStyle: {
                                  "font-weight": "400",
                                  "font-size": "36px !important",
                                  "line-height": "39px",
                                  "text-align": "center",
                                  color: "#0855C4",
                                  "margin-top": "30px"
                                }
                              },
                              [
                                _vm._v(
                                  "¿Deseas saber como registrar un siniestro?"
                                )
                              ]
                            ),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "padding-top": "20px",
                                  "padding-bottom": "20px",
                                  "text-align": "center"
                                }
                              },
                              [
                                _vm._v(
                                  "Aquí podrás descargar el manual de los pasos, con la información necesaria."
                                )
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass:
                                  "btn-solicitud btn-pink-filled omnesMedium",
                                staticStyle: {
                                  margin: "0 auto",
                                  height: "50px",
                                  width: "220px"
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadManual()
                                  }
                                }
                              },
                              [_vm._v("Descargar manual")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.sectionRegistroSiniestro
        ? _c("div", { staticClass: "section-registro-siniestro" }, [
            _vm._m(5),
            _vm._m(6)
          ])
        : _vm._e(),
      _vm.sectionMenu
        ? _c("div", { attrs: { id: "section-menu" } }, [
            _c("div", { staticClass: "section-content" }, [
              _c("h2", { staticStyle: { "align-text": "center" } }, [
                _vm._v("Selecciona tu producto")
              ]),
              _c("section", { staticClass: "menu" }, [
                _c("div", { staticClass: "item-button menu-principal" }, [
                  _c(
                    "article",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToCoberturas("Vida")
                        }
                      }
                    },
                    [_vm._m(7)]
                  ),
                  _c("h3", [_vm._v("Seguro de Vida")])
                ]),
                _c("div", { staticClass: "item-button menu-principal" }, [
                  _c(
                    "article",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToCoberturas("SOAT")
                        }
                      }
                    },
                    [_vm._m(8)]
                  ),
                  _c("h3", [_vm._v("SOAT")])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "item-button menu-principal only-desktop-flex"
                  },
                  [
                    _c(
                      "article",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToCoberturas("Protección tarjeta")
                          }
                        }
                      },
                      [_vm._m(9)]
                    ),
                    _c("h3", [_vm._v("Protección de tarjetas")])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "item-button menu-principal only-desktop-flex"
                  },
                  [
                    _c(
                      "article",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToCoberturas("Protección financiera")
                          }
                        }
                      },
                      [_vm._m(10)]
                    ),
                    _c("h3", [_vm._v("Protección financiera")])
                  ]
                )
              ]),
              _c("section", { staticClass: "menu only-desktop-flex" }, [
                _c(
                  "div",
                  {
                    staticClass: "item-button menu-principal only-desktop-flex"
                  },
                  [
                    _c(
                      "article",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToCoberturas("Desgravamen")
                          }
                        }
                      },
                      [_vm._m(11)]
                    ),
                    _c("h3", [_vm._v("Desgravamen")])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "item-button menu-principal only-desktop-flex"
                  },
                  [
                    _c(
                      "article",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToCoberturas("Vida Ley")
                          }
                        }
                      },
                      [_vm._m(12)]
                    ),
                    _c("h3", [_vm._v("Vida ley")])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "item-button menu-principal only-desktop-flex"
                  },
                  [
                    _c(
                      "article",
                      {
                        on: {
                          click: function($event) {
                            return _vm.goToCoberturas("Renta Hospitalaria")
                          }
                        }
                      },
                      [_vm._m(13)]
                    ),
                    _c("h3", [_vm._v("Renta Hospitalaria")])
                  ]
                ),
                _c("div", {
                  staticClass: "item-button menu-principal only-desktop-flex",
                  staticStyle: { "pointer-events": "none" }
                })
              ]),
              _c("section", { staticClass: "menu only-mobile-flex" }, [
                _c("div", { staticClass: "item-button menu-principal" }, [
                  _c(
                    "article",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToCoberturas("Protección tarjeta")
                        }
                      }
                    },
                    [_vm._m(14)]
                  ),
                  _c("h3", [_vm._v("Protección de tarjetas")])
                ]),
                _c("div", { staticClass: "item-button menu-principal" }, [
                  _c(
                    "article",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToCoberturas("Protección financiera")
                        }
                      }
                    },
                    [_vm._m(15)]
                  ),
                  _c("h3", [_vm._v("Protección financiera")])
                ])
              ]),
              _c("section", { staticClass: "menu only-mobile-flex" }, [
                _c("div", { staticClass: "item-button menu-principal" }, [
                  _c(
                    "article",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToCoberturas("Desgravamen")
                        }
                      }
                    },
                    [_vm._m(16)]
                  ),
                  _c("h3", [_vm._v("Desgravamen")])
                ]),
                _c("div", { staticClass: "item-button menu-principal" }, [
                  _c(
                    "article",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToCoberturas("Vida Ley")
                        }
                      }
                    },
                    [_vm._m(17)]
                  ),
                  _c("h3", [_vm._v("Vida Ley")])
                ])
              ]),
              _c("section", { staticClass: "menu only-mobile-flex" }, [
                _c("div", { staticClass: "item-button menu-principal" }, [
                  _c(
                    "article",
                    {
                      on: {
                        click: function($event) {
                          return _vm.goToCoberturas("Renta Hospitalaria")
                        }
                      }
                    },
                    [_vm._m(18)]
                  ),
                  _c("h3", [_vm._v("Renta Hospitalaria")])
                ]),
                _c("div", {
                  staticClass: "item-button menu-principal",
                  staticStyle: { "pointer-events": "none" }
                })
              ])
            ])
          ])
        : _vm._e(),
      _vm.sectionSubMenu
        ? _c("div", { attrs: { id: "section-submenu" } }, [
            _c(
              "div",
              { staticClass: "section-content" },
              [
                _c("h2", {
                  staticClass: "only-desktop",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.form.tipoPoliza.toLowerCase() === "soat"
                        ? "Seleccionar coberturas SOAT"
                        : "Selecciona cobertura del Seguro de Vida"
                    )
                  }
                }),
                _c("h2", {
                  staticClass: "only-mobile",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.form.tipoPoliza.toLowerCase() === "soat"
                        ? "Selecciona coberturas SOAT"
                        : "Selecciona cobertura del <br> Seguro de Vida"
                    )
                  }
                }),
                _vm.form.tipoPoliza.toLowerCase() === "soat"
                  ? _c(
                      "h3",
                      {
                        staticStyle: {
                          "text-align": "center",
                          color: "#0855c4",
                          "font-weight": "400"
                        }
                      },
                      [_vm._v("Puedes elegir más de una cobertura")]
                    )
                  : _vm._e(),
                _c(
                  "section",
                  { staticClass: "submenu" },
                  _vm._l(_vm.dataCoberturas, function(item) {
                    return _c(
                      "div",
                      { key: item.key, staticClass: "item-button" },
                      [
                        _c(
                          "v-tooltip",
                          {
                            staticClass: "only-desktop",
                            staticStyle: { "z-index": "112 !important" },
                            attrs: { bottom: "bottom" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        "article",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              style: item.selected
                                                ? "background: #0855C4 !important; cursor: pointer;"
                                                : "cursor: pointer;",
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectCobertura(
                                                    item.key
                                                  )
                                                }
                                              }
                                            },
                                            "article",
                                            attrs,
                                            false
                                          ),
                                          item.tooltip ? on : null
                                        ),
                                        [
                                          _c("figure", [
                                            _c("img", {
                                              attrs: {
                                                src: require("../assets/img/" +
                                                  item.img)
                                              }
                                            })
                                          ])
                                        ]
                                      ),
                                      _c(
                                        "h3",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectCobertura(
                                                    item.key
                                                  )
                                                }
                                              }
                                            },
                                            "h3",
                                            attrs,
                                            false
                                          ),
                                          item.tooltip ? on : null
                                        ),
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            item.tooltip
                              ? _c("span", {
                                  staticClass: "tooltip-poput only-desktop",
                                  staticStyle: { color: "#FFF" },
                                  domProps: { innerHTML: _vm._s(item.tooltip) }
                                })
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c(
                  "v-layout",
                  {
                    attrs: {
                      row: "row",
                      wrap: "wrap",
                      "justify-center": "justify-center"
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass:
                          "btn-solicitud btn-pink-filled omnesSemibold",
                        staticStyle: { height: "50px" },
                        attrs: {
                          id: "btn-coverages",
                          type: "button",
                          disabled: _vm.coberturasSeleccionadas.length === 0
                        },
                        on: {
                          click: function($event) {
                            return _vm.goToDatos()
                          }
                        }
                      },
                      [_vm._v("Continuar")]
                    )
                  ],
                  1
                ),
                _c(
                  "v-layout",
                  {
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      row: "row",
                      wrap: "wrap",
                      "justify-center": "justify-center"
                    }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn-volver",
                        on: {
                          click: function($event) {
                            return _vm.goBackToRegistro()
                          }
                        }
                      },
                      [_vm._v("Volver")]
                    )
                  ]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.sectionSolicitud
        ? _c(
            "div",
            { attrs: { id: "section-solicitud" } },
            [
              _vm.sectionStepper
                ? _c(
                    "v-flex",
                    { staticClass: "stepper" },
                    [
                      _c(
                        "v-stepper",
                        {
                          attrs: {
                            id: "main-stepper",
                            "alt-labels": "alt-labels"
                          },
                          model: {
                            value: _vm.stepperPoint,
                            callback: function($$v) {
                              _vm.stepperPoint = $$v
                            },
                            expression: "stepperPoint"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "row",
                                wrap: "wrap",
                                "justify-center": "justify-center"
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs8: "xs8",
                                    sm6: "sm6",
                                    md4: "md4",
                                    lg3: "lg3"
                                  }
                                },
                                [
                                  _c(
                                    "v-stepper-header",
                                    [
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            step: "1",
                                            complete: _vm.stepperPoint >= 1
                                          }
                                        },
                                        [_vm._v("Solicitud")]
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-stepper-step",
                                        {
                                          attrs: {
                                            step: "2",
                                            complete: _vm.stepperPoint >= 2
                                          }
                                        },
                                        [_vm._v("Resumen")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.sectionDatos
                ? _c(
                    "v-layout",
                    {
                      staticStyle: { "margin-top": "-20px" },
                      attrs: {
                        row: "row",
                        wrap: "wrap",
                        "justify-center": "justify-center"
                      }
                    },
                    [
                      _c("div", { staticClass: "section-content" }, [
                        _c("h2", { staticClass: "subtitle-content" }, [
                          _vm._v("Completa la información")
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.sectionDatos ? _c("br") : _vm._e(),
              _c(
                "v-layout",
                {
                  staticStyle: { "margin-bottom": "40px" },
                  attrs: {
                    row: "row",
                    wrap: "wrap",
                    "justify-center": "justify-center"
                  }
                },
                [
                  _vm.sectionDatos
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "view_myproduct",
                          attrs: {
                            xs0: "xs0",
                            sm0: "sm0",
                            md5: "md5",
                            lg4: "lg4"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            [
                              _c("v-flex", { staticClass: "myproduct" }, [
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "omnesMedium mp-title only-desktop"
                                  },
                                  [_vm._v("Datos")]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "section-solicitud-datos",
                                    staticStyle: { "margin-bottom": "0px" }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass: "row-mp-subtitle",
                                        style: _vm.aseguradoComprimido
                                          ? {
                                              "border-bottom":
                                                "1px solid #E7EAED"
                                            }
                                          : {}
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { lg9: "lg9" } },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "row" },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "omnesRegular mp-subtitle"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "1. Datos del " +
                                                        _vm._s(
                                                          _vm.form.tipoPoliza.toLowerCase() ===
                                                            "soat"
                                                            ? "lesionado"
                                                            : "asegurado"
                                                        )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    staticStyle: {
                                                      "z-index":
                                                        "112 !important"
                                                    },
                                                    attrs: { bottom: "bottom" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "svg",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      staticStyle: {
                                                                        height:
                                                                          "14px",
                                                                        "align-self":
                                                                          "center",
                                                                        "margin-left":
                                                                          "5px"
                                                                      },
                                                                      attrs: {
                                                                        viewBox:
                                                                          "0 0 12 12",
                                                                        fill:
                                                                          "none",
                                                                        xmlns:
                                                                          "http://www.w3.org/2000/svg",
                                                                        preserveAspectRatio:
                                                                          "none"
                                                                      }
                                                                    },
                                                                    "svg",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c("path", {
                                                                    attrs: {
                                                                      d:
                                                                        "M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z",
                                                                      fill:
                                                                        "#D0D6E0"
                                                                    }
                                                                  }),
                                                                  _c("path", {
                                                                    attrs: {
                                                                      d:
                                                                        "M5.51732 6.7122C5.72044 6.7122 5.86306 6.6504 5.87948 6.51772C5.8972 5.89019 6.33025 5.63477 6.76329 5.35126C7.01558 5.23228 7.22954 5.04509 7.381 4.81085C7.53245 4.5766 7.61534 4.30466 7.6203 4.02577C7.6203 3.15104 6.92233 2.52351 5.7736 2.52351C5.25094 2.50066 4.73917 2.67758 4.34222 3.01836C4.20972 3.1306 4.10088 3.26806 4.02201 3.42276C3.94314 3.57746 3.89582 3.7463 3.88281 3.91945C3.88281 4.39485 4.49262 4.4143 4.50126 4.38794C4.52045 4.07346 4.66274 3.77921 4.89732 3.56889C5.1319 3.35858 5.43989 3.24914 5.75458 3.26427C6.39075 3.26427 6.75292 3.591 6.75292 4.09492C6.75292 4.55433 6.36396 4.72244 5.96635 4.98737C5.71309 5.12804 5.50295 5.33506 5.3585 5.58619C5.21406 5.83731 5.14077 6.12305 5.14651 6.4127C5.13743 6.61496 5.29647 6.7122 5.51732 6.7122ZM5.4741 8.4085H5.5977C5.6626 8.41701 5.72859 8.41066 5.79068 8.38993C5.85277 8.3692 5.90934 8.33465 5.95612 8.28886C6.00291 8.24308 6.03868 8.18727 6.06074 8.12564C6.0828 8.06401 6.09057 7.99818 6.08347 7.9331V7.82722C6.09146 7.76134 6.08438 7.69451 6.06277 7.63176C6.04116 7.56902 6.00558 7.512 5.95871 7.46501C5.91185 7.41802 5.85493 7.38229 5.79224 7.36051C5.72955 7.33873 5.66274 7.33148 5.59684 7.33929H5.47323C5.40831 7.33286 5.34277 7.3411 5.28145 7.3634C5.22014 7.3857 5.16461 7.42148 5.11898 7.46811C5.07335 7.51474 5.03877 7.57102 5.0178 7.6328C4.99683 7.69459 4.99001 7.76029 4.99784 7.82506V7.93094C4.99009 7.99533 4.99704 8.06064 5.01816 8.12195C5.03928 8.18327 5.07402 8.239 5.11977 8.28496C5.16553 8.33092 5.2211 8.36591 5.28232 8.38731C5.34354 8.40871 5.40881 8.41596 5.47323 8.4085H5.4741Z",
                                                                      fill:
                                                                        "white"
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      2408529523
                                                    )
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "tooltip-poput",
                                                        staticStyle: {
                                                          color: "#FFF"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "El lesionado es aquella persona que sufre un accidente "
                                                        ),
                                                        _c("br", {
                                                          staticClass:
                                                            "only-dektop"
                                                        }),
                                                        _vm._v(
                                                          " o siniestro. También puede ser el solicitante."
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c("div", { staticClass: "row" }, [
                                              _vm.form.asegurado.nombres &&
                                              _vm.form.asegurado
                                                .apellidoPaterno &&
                                              _vm.aseguradoComprimido
                                                ? _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "omnesRegular mp",
                                                      staticStyle: {
                                                        "padding-left": "20px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.form.asegurado.nombres.split(
                                                            " "
                                                          )[0] +
                                                            " " +
                                                            _vm.form.asegurado
                                                              .apellidoPaterno +
                                                            " "
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          ]
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "col-mp-button",
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content": "flex-end"
                                            },
                                            attrs: { lg3: "lg3" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                style: _vm.aseguradoComprimido
                                                  ? {
                                                      "font-weight": "500",
                                                      "margin-top": "-5px"
                                                    }
                                                  : {
                                                      "font-weight": "700",
                                                      "margin-top": "-5px"
                                                    },
                                                on: {
                                                  click: function($event) {
                                                    _vm.aseguradoComprimido = !_vm.aseguradoComprimido
                                                  }
                                                }
                                              },
                                              [_vm._v("Editar")]
                                            ),
                                            _c(
                                              "svg",
                                              {
                                                class: _vm.aseguradoComprimido
                                                  ? "arrow-down"
                                                  : "arrow-up",
                                                staticStyle: {
                                                  "align-self": "center"
                                                },
                                                attrs: {
                                                  width: "7",
                                                  height: "12",
                                                  viewBox: "0 0 8 16",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z",
                                                    fill: "#0855C4"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    !_vm.aseguradoComprimido
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "section-data-content"
                                          },
                                          [
                                            _c(
                                              "v-layout",
                                              { staticClass: "row-mp-data" },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Apellido Paterno",
                                                    outline: "outline"
                                                  },
                                                  on: {
                                                    keydown: function(event) {
                                                      return _vm.onlyText(event)
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.asegurado
                                                        .apellidoPaterno,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form.asegurado,
                                                        "apellidoPaterno",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.asegurado.apellidoPaterno"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-layout",
                                              { staticClass: "row-mp-data" },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Apellido Materno",
                                                    outline: "outline"
                                                  },
                                                  on: {
                                                    keydown: function(event) {
                                                      return _vm.onlyText(event)
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.asegurado
                                                        .apellidoMaterno,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form.asegurado,
                                                        "apellidoMaterno",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.asegurado.apellidoMaterno"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-layout",
                                              { staticClass: "row-mp-data" },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Nombres",
                                                    outline: "outline",
                                                    "browser-autocomplete":
                                                      "off"
                                                  },
                                                  on: {
                                                    keydown: function(event) {
                                                      return _vm.onlyText(event)
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.asegurado
                                                        .nombres,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form.asegurado,
                                                        "nombres",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.asegurado.nombres"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-layout",
                                              { staticClass: "row-mp-data" },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      "N° de documento DNI/CE",
                                                    outline: "outline",
                                                    "browser-autocomplete":
                                                      "off"
                                                  },
                                                  on: {
                                                    keydown: function(event) {
                                                      return _vm.onlyNumbers(
                                                        event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.asegurado
                                                        .nroDocumento,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form.asegurado,
                                                        "nroDocumento",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.asegurado.nroDocumento"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm.sectionSolicitante
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "section-solicitud-datos"
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "row-mp-subtitle",
                                            style: _vm.solicitanteComprimido
                                              ? {
                                                  "border-bottom":
                                                    "1px solid #E7EAED"
                                                }
                                              : {}
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "flex-direction": "column",
                                                  "margin-left": "-15px",
                                                  "margin-right": "15px"
                                                },
                                                attrs: { lg9: "lg9" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "row",
                                                    staticStyle: {
                                                      width: "100%"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "omnesRegular mp-subtitle"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "2. Datos del solicitante"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "row",
                                                    staticStyle: {
                                                      width: "100%"
                                                    }
                                                  },
                                                  [
                                                    _vm.form.solicitante
                                                      .nombres &&
                                                    _vm.form.solicitante
                                                      .apellidoPaterno &&
                                                    _vm.solicitanteComprimido
                                                      ? _c(
                                                          "h5",
                                                          {
                                                            staticClass:
                                                              "omnesRegular mp",
                                                            staticStyle: {
                                                              "padding-left":
                                                                "20px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.form.solicitante.nombres.split(
                                                                  " "
                                                                )[0] +
                                                                  " " +
                                                                  _vm.form
                                                                    .solicitante
                                                                    .apellidoPaterno
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "col-mp-button",
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "justify-content": "flex-end"
                                                },
                                                attrs: { lg3: "lg3" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: _vm.solicitanteComprimido
                                                      ? {
                                                          "font-weight": "500",
                                                          "margin-top": "-5px"
                                                        }
                                                      : {
                                                          "font-weight": "700",
                                                          "margin-top": "-5px"
                                                        },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.solicitanteComprimido = !_vm.solicitanteComprimido
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Editar")]
                                                ),
                                                _c(
                                                  "svg",
                                                  {
                                                    class: _vm.solicitanteComprimido
                                                      ? "arrow-down"
                                                      : "arrow-up",
                                                    staticStyle: {
                                                      "align-self": "center"
                                                    },
                                                    attrs: {
                                                      width: "7",
                                                      height: "12",
                                                      viewBox: "0 0 8 16",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z",
                                                        fill: "#0855C4"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        !_vm.solicitanteComprimido
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "section-data-content"
                                              },
                                              [
                                                !this.coberturasSeleccionadas.includes(
                                                  "Fallecimiento"
                                                )
                                                  ? _c(
                                                      "v-layout",
                                                      {
                                                        staticClass:
                                                          "row-mp-data",
                                                        staticStyle: {
                                                          "margin-top": "-45px"
                                                        }
                                                      },
                                                      [
                                                        _c("v-checkbox", {
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.copyInsured()
                                                            }
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "label",
                                                                fn: function() {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "selected-insured-copy",
                                                                        class: _vm.selectedInsuredCopy
                                                                          ? "checked"
                                                                          : "unchecked"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Marque la casilla si los datos del solicitante son los mismos que el " +
                                                                            _vm._s(
                                                                              _vm.form.tipoPoliza.toLowerCase() ===
                                                                                "soat"
                                                                                ? "lesionado"
                                                                                : "asegurado"
                                                                            ) +
                                                                            "."
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                },
                                                                proxy: true
                                                              }
                                                            ],
                                                            null,
                                                            false,
                                                            965671020
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.selectedInsuredCopy,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.selectedInsuredCopy = $$v
                                                            },
                                                            expression:
                                                              "selectedInsuredCopy"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          "Apellido Paterno",
                                                        outline: "outline"
                                                      },
                                                      on: {
                                                        keydown: function(
                                                          event
                                                        ) {
                                                          return _vm.onlyText(
                                                            event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.solicitante
                                                            .apellidoPaterno,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .solicitante,
                                                            "apellidoPaterno",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.solicitante.apellidoPaterno"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          "Apellido Materno",
                                                        outline: "outline"
                                                      },
                                                      on: {
                                                        keydown: function(
                                                          event
                                                        ) {
                                                          return _vm.onlyText(
                                                            event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.solicitante
                                                            .apellidoMaterno,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .solicitante,
                                                            "apellidoMaterno",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.solicitante.apellidoMaterno"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: "Nombres",
                                                        outline: "outline",
                                                        "browser-autocomplete":
                                                          "off"
                                                      },
                                                      on: {
                                                        keydown: function(
                                                          event
                                                        ) {
                                                          return _vm.onlyText(
                                                            event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.solicitante
                                                            .nombres,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .solicitante,
                                                            "nombres",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.solicitante.nombres"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          "N° de documento DNI/CE",
                                                        outline: "outline",
                                                        "browser-autocomplete":
                                                          "off"
                                                      },
                                                      on: {
                                                        keydown: function(
                                                          event
                                                        ) {
                                                          return _vm.onlyNumbers(
                                                            event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.solicitante
                                                            .nroDocumento,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .solicitante,
                                                            "nroDocumento",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.solicitante.nroDocumento"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data",
                                                    staticStyle: {
                                                      display: "flex",
                                                      "flex-direction": "column"
                                                    }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          "Correo electrónico",
                                                        outline: "outline",
                                                        "browser-autocomplete":
                                                          "off"
                                                      },
                                                      on: {
                                                        blur: _vm.validateEmail,
                                                        keydown: function() {
                                                          return _vm.revalidateEmail()
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.solicitante
                                                            .correo,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .solicitante,
                                                            "correo",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.solicitante.correo"
                                                      }
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.showErrorMessage,
                                                            expression:
                                                              "showErrorMessage"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "error-message",
                                                        staticStyle: {
                                                          color: "red",
                                                          margin:
                                                            "-25px 26px 25px 20px",
                                                          "font-size": "15px",
                                                          "text-align":
                                                            "justify",
                                                          "line-height": "16px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          'Ingrese un correo electrónico válido. Ej: "micorreo@gmail.com"'
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: "Celular",
                                                        outline: "outline",
                                                        "browser-autocomplete":
                                                          "off"
                                                      },
                                                      on: {
                                                        keydown: function(
                                                          event
                                                        ) {
                                                          return _vm.onlyNumbers(
                                                            event,
                                                            9
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.solicitante
                                                            .celular,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form
                                                              .solicitante,
                                                            "celular",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.solicitante.celular"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticStyle: {
                                                          margin:
                                                            "0px 0px 0px -15px"
                                                        },
                                                        attrs: {
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                          width: "42",
                                                          height: "42",
                                                          viewbox: "0 0 42 42",
                                                          fill: "none"
                                                        }
                                                      },
                                                      [
                                                        _c("circle", {
                                                          attrs: {
                                                            cx: "6.5",
                                                            cy: "6.5",
                                                            r: "6.5",
                                                            fill: "#454A6C"
                                                          }
                                                        }),
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M6.666 8.508C6.498 8.508 6.47 8.382 6.456 8.172L6.148 2.432C6.134 2.012 6.302 1.886 6.554 1.886H6.904C7.156 1.886 7.324 2.012 7.31 2.432L7.002 8.172C6.988 8.382 6.96 8.508 6.778 8.508H6.666ZM6.652 11.084C6.26 11.084 6.036 10.86 6.036 10.468V10.328C6.036 9.936 6.26 9.698 6.652 9.698H6.792C7.198 9.698 7.422 9.936 7.422 10.328V10.468C7.422 10.86 7.198 11.084 6.792 11.084H6.652Z",
                                                            fill: "white"
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                          "text-align":
                                                            "justify",
                                                          "line-height": "15px",
                                                          margin:
                                                            "-5px 5px 12px 0px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Antes de continuar,  "
                                                        ),
                                                        _c("strong", [
                                                          _vm._v(
                                                            "verifica que tu correo electrónico y número de celular sean los correctos"
                                                          )
                                                        ]),
                                                        _vm._v("."),
                                                        _c("br"),
                                                        _c("br"),
                                                        _vm._v(
                                                          "Toda comunicación respecto a tu caso será notificada por cualquiera de estos medios."
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.sectionNarracion
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "section-solicitud-datos"
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "row-mp-subtitle",
                                            style: _vm.narracionComprimido
                                              ? {
                                                  "border-bottom":
                                                    "1px solid #E7EAED"
                                                }
                                              : {}
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { lg9: "lg9" } },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "omnesRegular mp-subtitle"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "3. Narración del siniestro (Obligatorio)"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _vm.form.narracion &&
                                                    _vm.narracionComprimido
                                                      ? _c(
                                                          "h5",
                                                          {
                                                            staticClass:
                                                              "omnesRegular mp",
                                                            staticStyle: {
                                                              "white-space":
                                                                "nowrap",
                                                              overflow:
                                                                "hidden",
                                                              "text-overflow":
                                                                "ellipsis",
                                                              width: "250px",
                                                              "padding-left":
                                                                "20px"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.form
                                                                  .narracion
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "col-mp-button",
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "justify-content": "flex-end"
                                                },
                                                attrs: { lg3: "lg3" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: _vm.narracionComprimido
                                                      ? {
                                                          "font-weight": "500",
                                                          "margin-top": "-5px"
                                                        }
                                                      : {
                                                          "font-weight": "700",
                                                          "margin-top": "-5px"
                                                        },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.narracionComprimido = !_vm.narracionComprimido
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Editar")]
                                                ),
                                                _c(
                                                  "svg",
                                                  {
                                                    class: _vm.narracionComprimido
                                                      ? "arrow-down"
                                                      : "arrow-up",
                                                    staticStyle: {
                                                      "align-self": "center"
                                                    },
                                                    attrs: {
                                                      width: "7",
                                                      height: "12",
                                                      viewBox: "0 0 8 16",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z",
                                                        fill: "#0855C4"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        !_vm.narracionComprimido
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "section-data-content"
                                              },
                                              [
                                                _vm.showFechaOcurrencia()
                                                  ? _c(
                                                      "v-layout",
                                                      {
                                                        staticClass:
                                                          "row-mp-data"
                                                      },
                                                      [
                                                        _c("date-picker", {
                                                          staticStyle: {
                                                            "min-width": "50%"
                                                          },
                                                          attrs: {
                                                            label:
                                                              "Fecha de ocurrencia",
                                                            max:
                                                              _vm.currentDateCalendar
                                                          },
                                                          on: {
                                                            changeDate: function(
                                                              date
                                                            ) {
                                                              return (_vm.form.fechaOcurrencia = date)
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.showFechasIncapacidad()
                                                  ? _c(
                                                      "v-layout",
                                                      {
                                                        staticClass:
                                                          "row-mp-data"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticStyle: {
                                                              "text-align":
                                                                "justify"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Fechas de incapacidad:"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._l(
                                                  _vm.form.fechasIncapacidad,
                                                  function(fecha, index) {
                                                    return _vm.showFechasIncapacidad()
                                                      ? _c(
                                                          "v-layout",
                                                          {
                                                            key: index,
                                                            staticClass:
                                                              "row-mp-data",
                                                            staticStyle: {
                                                              "align-items":
                                                                "baseline"
                                                            }
                                                          },
                                                          [
                                                            _c("date-picker", {
                                                              attrs: {
                                                                label:
                                                                  "Fecha inicio"
                                                              },
                                                              on: {
                                                                changeDate: function(
                                                                  date
                                                                ) {
                                                                  return (_vm.form.fechasIncapacidad[
                                                                    index
                                                                  ].fechaInicioIncapacidad = date)
                                                                }
                                                              }
                                                            }),
                                                            _c("date-picker", {
                                                              attrs: {
                                                                label:
                                                                  "Fecha fin"
                                                              },
                                                              on: {
                                                                changeDate: function(
                                                                  date
                                                                ) {
                                                                  return (_vm.form.fechasIncapacidad[
                                                                    index
                                                                  ].fechaFinIncapacidad = date)
                                                                }
                                                              }
                                                            }),
                                                            _vm.form
                                                              .fechasIncapacidad
                                                              .length > 1
                                                              ? _c("img", {
                                                                  staticStyle: {
                                                                    cursor:
                                                                      "pointer",
                                                                    width:
                                                                      "25px"
                                                                  },
                                                                  attrs: {
                                                                    src:
                                                                      _vm.images
                                                                        .iconClose
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeFechasIncapacidad(
                                                                        index
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  }
                                                ),
                                                _vm.showFechasIncapacidad() &&
                                                _vm.form.fechasIncapacidad
                                                  .length < 4
                                                  ? _c(
                                                      "v-layout",
                                                      {
                                                        staticClass:
                                                          "row-mp-data"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "plus-icon2",
                                                            staticStyle: {
                                                              color: "#0855C4",
                                                              "font-size":
                                                                "14px",
                                                              "font-weight":
                                                                "700",
                                                              cursor: "pointer",
                                                              padding:
                                                                "0.3em 1em"
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.addFechasIncapacidad
                                                            }
                                                          },
                                                          [
                                                            _c("i", [
                                                              _c(
                                                                "svg",
                                                                {
                                                                  attrs: {
                                                                    width: "16",
                                                                    height:
                                                                      "16",
                                                                    viewbox:
                                                                      "2 2 32 16",
                                                                    fill:
                                                                      "#454A6C",
                                                                    xmlns:
                                                                      "http://www.w3.org/2000/svg"
                                                                  }
                                                                },
                                                                [
                                                                  _c("path", {
                                                                    attrs: {
                                                                      "fill-rule":
                                                                        "evenodd",
                                                                      d:
                                                                        "M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z",
                                                                      "clip-rule":
                                                                        "evenodd"
                                                                    }
                                                                  }),
                                                                  _c("path", {
                                                                    attrs: {
                                                                      "fill-rule":
                                                                        "evenodd",
                                                                      d:
                                                                        "M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z",
                                                                      "clip-rule":
                                                                        "evenodd"
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "Agregar fechas"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.showMontoSolicitado()
                                                  ? _c(
                                                      "v-layout",
                                                      {
                                                        staticClass:
                                                          "row-mp-data"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label:
                                                              _vm.form.tipoPoliza.toLowerCase() ===
                                                              "soat"
                                                                ? "Monto solicitado para gastos médicos"
                                                                : "Monto solicitado",
                                                            outline: "outline"
                                                          },
                                                          on: {
                                                            keydown: function(
                                                              event
                                                            ) {
                                                              return _vm.onlyNumbers(
                                                                event
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form
                                                                .montoSolicitado,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "montoSolicitado",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.montoSolicitado"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.showPagador()
                                                  ? _c(
                                                      "v-layout",
                                                      {
                                                        staticClass:
                                                          "row-mp-data"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label:
                                                              "Nombre del que pagó los gastos médicos",
                                                            outline: "outline"
                                                          },
                                                          on: {
                                                            keydown: function(
                                                              event
                                                            ) {
                                                              return _vm.onlyText(
                                                                event
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form.pagador,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "pagador",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.pagador"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          "text-align":
                                                            "justify"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Puedes contarnos brevemente tu caso y si lo deseas nos pondremos en contacto contigo."
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c("v-textarea", {
                                                      class:
                                                        _vm.form.narracion
                                                          .length > 0
                                                          ? "without-placeholder"
                                                          : "",
                                                      attrs: {
                                                        label:
                                                          _vm.form.narracion
                                                            .length > 0
                                                            ? ""
                                                            : "Cuéntanos aquí...",
                                                        outline: "outline",
                                                        maxlength: 250
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.narracion,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "narracion",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.narracion"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "15px",
                                                          "margin-top": "-15px",
                                                          "font-size": "13px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Máximo 250 caracteres."
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.sectionMetodoPago
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "section-solicitud-datos"
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "row-mp-subtitle",
                                            style: _vm.metodoPagoComprimido
                                              ? {
                                                  "border-bottom":
                                                    "1px solid #E7EAED"
                                                }
                                              : {}
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { lg9: "lg9" } },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "omnesRegular mp-subtitle"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "4. Método de pago"
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        staticStyle: {
                                                          "z-index":
                                                            "112 !important"
                                                        },
                                                        attrs: {
                                                          bottom: "bottom"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var on = ref.on
                                                                var attrs =
                                                                  ref.attrs
                                                                return [
                                                                  _c(
                                                                    "svg",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticStyle: {
                                                                            height:
                                                                              "14px",
                                                                            "align-self":
                                                                              "center",
                                                                            "margin-left":
                                                                              "5px"
                                                                          },
                                                                          attrs: {
                                                                            viewBox:
                                                                              "0 0 12 12",
                                                                            fill:
                                                                              "none",
                                                                            xmlns:
                                                                              "http://www.w3.org/2000/svg",
                                                                            preserveAspectRatio:
                                                                              "none"
                                                                          }
                                                                        },
                                                                        "svg",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z",
                                                                            fill:
                                                                              "#D0D6E0"
                                                                          }
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs: {
                                                                            d:
                                                                              "M5.51732 6.7122C5.72044 6.7122 5.86306 6.6504 5.87948 6.51772C5.8972 5.89019 6.33025 5.63477 6.76329 5.35126C7.01558 5.23228 7.22954 5.04509 7.381 4.81085C7.53245 4.5766 7.61534 4.30466 7.6203 4.02577C7.6203 3.15104 6.92233 2.52351 5.7736 2.52351C5.25094 2.50066 4.73917 2.67758 4.34222 3.01836C4.20972 3.1306 4.10088 3.26806 4.02201 3.42276C3.94314 3.57746 3.89582 3.7463 3.88281 3.91945C3.88281 4.39485 4.49262 4.4143 4.50126 4.38794C4.52045 4.07346 4.66274 3.77921 4.89732 3.56889C5.1319 3.35858 5.43989 3.24914 5.75458 3.26427C6.39075 3.26427 6.75292 3.591 6.75292 4.09492C6.75292 4.55433 6.36396 4.72244 5.96635 4.98737C5.71309 5.12804 5.50295 5.33506 5.3585 5.58619C5.21406 5.83731 5.14077 6.12305 5.14651 6.4127C5.13743 6.61496 5.29647 6.7122 5.51732 6.7122ZM5.4741 8.4085H5.5977C5.6626 8.41701 5.72859 8.41066 5.79068 8.38993C5.85277 8.3692 5.90934 8.33465 5.95612 8.28886C6.00291 8.24308 6.03868 8.18727 6.06074 8.12564C6.0828 8.06401 6.09057 7.99818 6.08347 7.9331V7.82722C6.09146 7.76134 6.08438 7.69451 6.06277 7.63176C6.04116 7.56902 6.00558 7.512 5.95871 7.46501C5.91185 7.41802 5.85493 7.38229 5.79224 7.36051C5.72955 7.33873 5.66274 7.33148 5.59684 7.33929H5.47323C5.40831 7.33286 5.34277 7.3411 5.28145 7.3634C5.22014 7.3857 5.16461 7.42148 5.11898 7.46811C5.07335 7.51474 5.03877 7.57102 5.0178 7.6328C4.99683 7.69459 4.99001 7.76029 4.99784 7.82506V7.93094C4.99009 7.99533 4.99704 8.06064 5.01816 8.12195C5.03928 8.18327 5.07402 8.239 5.11977 8.28496C5.16553 8.33092 5.2211 8.36591 5.28232 8.38731C5.34354 8.40871 5.40881 8.41596 5.47323 8.4085H5.4741Z",
                                                                            fill:
                                                                              "white"
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          false,
                                                          2408529523
                                                        )
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tooltip-poput",
                                                            staticStyle: {
                                                              color: "#FFF"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "La cuenta bancaria registrada se utilizará "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              " en el caso la solucitud sea procesada."
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "col-mp-button",
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  "justify-content": "flex-end"
                                                },
                                                attrs: { lg3: "lg3" }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: _vm.metodoPagoComprimido
                                                      ? {
                                                          "font-weight": "500",
                                                          "margin-top": "-5px"
                                                        }
                                                      : {
                                                          "font-weight": "700",
                                                          "margin-top": "-5px"
                                                        },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.metodoPagoComprimido = !_vm.metodoPagoComprimido
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Editar")]
                                                ),
                                                _c(
                                                  "svg",
                                                  {
                                                    class: _vm.metodoPagoComprimido
                                                      ? "arrow-down"
                                                      : "arrow-up",
                                                    staticStyle: {
                                                      "align-self": "center"
                                                    },
                                                    attrs: {
                                                      width: "7",
                                                      height: "12",
                                                      viewBox: "0 0 8 16",
                                                      fill: "none",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z",
                                                        fill: "#0855C4"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        !_vm.metodoPagoComprimido
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "section-data-content"
                                              },
                                              [
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _vm.form.tipoPoliza.toLowerCase() ===
                                                    "vida"
                                                      ? _c("p", [
                                                          _vm._v(
                                                            "En caso tu solicitud sea aprobada, elige cómo recibir tu pago por transferencia o cobrarlo en ventanilla."
                                                          )
                                                        ])
                                                      : _c("p", [
                                                          _vm._v(
                                                            "En caso tu solicitud sea aprobada, elige cómo recibir tu pago por transferencia o cobrarlo en ventanilla."
                                                          )
                                                        ])
                                                  ]
                                                ),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    staticClass: "row-mp-data"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "box-blue-rounded"
                                                      },
                                                      [
                                                        _c("i", [
                                                          _c(
                                                            "svg",
                                                            {
                                                              attrs: {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox:
                                                                  "0 0 16 16",
                                                                fill: "none",
                                                                xmlns:
                                                                  "http://www.w3.org/2000/svg"
                                                              }
                                                            },
                                                            [
                                                              _c("path", {
                                                                attrs: {
                                                                  d:
                                                                    "M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z",
                                                                  fill: "white"
                                                                }
                                                              }),
                                                              _c("path", {
                                                                attrs: {
                                                                  d:
                                                                    "M7.00201 11.0001C7.00201 10.8688 7.02788 10.7388 7.07813 10.6174C7.12839 10.4961 7.20205 10.3859 7.29491 10.293C7.38777 10.2002 7.49801 10.1265 7.61933 10.0762C7.74066 10.026 7.87069 10.0001 8.00201 10.0001C8.13334 10.0001 8.26337 10.026 8.3847 10.0762C8.50602 10.1265 8.61626 10.2002 8.70912 10.293C8.80198 10.3859 8.87564 10.4961 8.92589 10.6174C8.97615 10.7388 9.00201 10.8688 9.00201 11.0001C9.00201 11.2653 8.89666 11.5197 8.70912 11.7072C8.52158 11.8948 8.26723 12.0001 8.00201 12.0001C7.7368 12.0001 7.48244 11.8948 7.29491 11.7072C7.10737 11.5197 7.00201 11.2653 7.00201 11.0001ZM7.10001 4.99512C7.0867 4.86896 7.10005 4.74141 7.13921 4.62075C7.17838 4.50008 7.24247 4.389 7.32733 4.2947C7.4122 4.20041 7.51594 4.12501 7.63183 4.0734C7.74771 4.02179 7.87315 3.99512 8.00001 3.99512C8.12687 3.99512 8.25232 4.02179 8.3682 4.0734C8.48409 4.12501 8.58783 4.20041 8.6727 4.2947C8.75756 4.389 8.82165 4.50008 8.86081 4.62075C8.89998 4.74141 8.91333 4.86896 8.90001 4.99512L8.55001 8.50212C8.53825 8.63989 8.47522 8.76823 8.37337 8.86175C8.27152 8.95528 8.13829 9.00717 8.00001 9.00717C7.86174 9.00717 7.7285 8.95528 7.62666 8.86175C7.52481 8.76823 7.46177 8.63989 7.45001 8.50212L7.10001 4.99512Z",
                                                                  fill: "white"
                                                                }
                                                              })
                                                            ]
                                                          )
                                                        ]),
                                                        _vm.form.tipoPoliza.toLowerCase() ===
                                                        "vida"
                                                          ? _c("p", [
                                                              _vm._v(
                                                                "Si alguno de los beneficiarios quiere recibir el pago en una cuenta bancaria puedes ingresarlo aquí."
                                                              )
                                                            ])
                                                          : _c("p", [
                                                              _vm._v(
                                                                "Recuerda que puedes optar por una transferencia a tu banco preferido para mayor rapidez y seguridad."
                                                              )
                                                            ])
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._l(
                                                  _vm.form.beneficiarios,
                                                  function(
                                                    beneficiario,
                                                    index
                                                  ) {
                                                    return _c(
                                                      "v-layout",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "mp-data-beneficiario",
                                                        staticStyle: {
                                                          "flex-direction":
                                                            "column"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-layout",
                                                          {
                                                            staticClass:
                                                              "row-mp-subtitle",
                                                            style: _vm
                                                              .beneficiariosComprimidos[
                                                              index
                                                            ]
                                                              ? {
                                                                  "border-bottom":
                                                                    "1px solid #E7EAED",
                                                                  margin: "10px"
                                                                }
                                                              : {
                                                                  margin: "10px"
                                                                }
                                                          },
                                                          [
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                  "align-items":
                                                                    "center",
                                                                  "flex-direction":
                                                                    "column"
                                                                },
                                                                attrs: {
                                                                  lg9: "lg9"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row",
                                                                    staticStyle: {
                                                                      width:
                                                                        "100%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "h4",
                                                                      {
                                                                        staticClass:
                                                                          "omnesRegular mp-subtitle"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            "Beneficiario " +
                                                                              (index +
                                                                                1)
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row",
                                                                    staticStyle: {
                                                                      width:
                                                                        "100%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm
                                                                      .beneficiariosComprimidos[
                                                                      index
                                                                    ]
                                                                      ? _c(
                                                                          "h5",
                                                                          {
                                                                            staticClass:
                                                                              "omnesRegular mp"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                !beneficiario.titular
                                                                                  ? beneficiario.metodoPago
                                                                                  : beneficiario.titular
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-flex",
                                                              {
                                                                staticClass:
                                                                  "col-mp-button",
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                  "align-items":
                                                                    "center",
                                                                  "justify-content":
                                                                    "flex-end"
                                                                },
                                                                attrs: {
                                                                  lg3: "lg3"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    style: _vm
                                                                      .beneficiariosComprimidos[
                                                                      index
                                                                    ]
                                                                      ? {
                                                                          "font-weight":
                                                                            "500",
                                                                          "margin-top":
                                                                            "-5px"
                                                                        }
                                                                      : {
                                                                          "font-weight":
                                                                            "700",
                                                                          "margin-top":
                                                                            "-5px"
                                                                        },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.beneficiarioEditarComprimir(
                                                                          index
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Editar"
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    class: _vm
                                                                      .beneficiariosComprimidos[
                                                                      index
                                                                    ]
                                                                      ? "arrow-down"
                                                                      : "arrow-up",
                                                                    staticStyle: {
                                                                      "align-self":
                                                                        "center"
                                                                    },
                                                                    attrs: {
                                                                      width:
                                                                        "7",
                                                                      height:
                                                                        "12",
                                                                      viewBox:
                                                                        "0 0 8 16",
                                                                      fill:
                                                                        "none",
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d:
                                                                          "M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z",
                                                                        fill:
                                                                          "#0855C4"
                                                                      }
                                                                    })
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        !_vm
                                                          .beneficiariosComprimidos[
                                                          index
                                                        ]
                                                          ? _c(
                                                              "div",
                                                              [
                                                                [
                                                                  "soat",
                                                                  "protección tarjeta"
                                                                ].includes(
                                                                  _vm.form.tipoPoliza.toLowerCase()
                                                                )
                                                                  ? _c(
                                                                      "v-layout",
                                                                      {
                                                                        staticClass:
                                                                          "row-mp-data"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          {
                                                                            staticClass:
                                                                              "select-box",
                                                                            attrs: {
                                                                              solo:
                                                                                "solo",
                                                                              items:
                                                                                _vm.metodosPago,
                                                                              label:
                                                                                "Método de pago",
                                                                              "menu-props":
                                                                                _vm.selectMenuProps
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.changeVentanillaTransferencia(
                                                                                  index,
                                                                                  beneficiario
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                beneficiario.metodoPago,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  beneficiario,
                                                                                  "metodoPago",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "beneficiario.metodoPago"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                beneficiario.metodoPago !==
                                                                  "Pago en ventanilla Interbank" &&
                                                                _vm.mostrarTransferencia
                                                                  ? _c(
                                                                      "v-layout",
                                                                      {
                                                                        staticClass:
                                                                          "row-mp-data"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "Número de cuenta",
                                                                              outline:
                                                                                "outline",
                                                                              "browser-autocomplete":
                                                                                "off"
                                                                            },
                                                                            on: {
                                                                              keydown: function(
                                                                                event
                                                                              ) {
                                                                                return _vm.onlyNumbers(
                                                                                  event,
                                                                                  20
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                beneficiario.nroCuenta,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  beneficiario,
                                                                                  "nroCuenta",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "beneficiario.nroCuenta"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _vm.mostrarTransferencia ||
                                                                _vm.mostrarVentanilla
                                                                  ? _c(
                                                                      "v-layout",
                                                                      {
                                                                        staticClass:
                                                                          "row-mp-data"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "Titular de la cuenta",
                                                                              outline:
                                                                                "outline",
                                                                              "browser-autocomplete":
                                                                                "off"
                                                                            },
                                                                            on: {
                                                                              keydown: function(
                                                                                event
                                                                              ) {
                                                                                return _vm.onlyText(
                                                                                  event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                beneficiario.titular,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  beneficiario,
                                                                                  "titular",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "beneficiario.titular"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _vm.mostrarTransferencia ||
                                                                _vm.mostrarVentanilla
                                                                  ? _c(
                                                                      "v-layout",
                                                                      {
                                                                        staticClass:
                                                                          "row-mp-data"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs: {
                                                                              label:
                                                                                "N° de documento DNI/CE",
                                                                              outline:
                                                                                "outline",
                                                                              "browser-autocomplete":
                                                                                "off"
                                                                            },
                                                                            on: {
                                                                              keydown: function(
                                                                                event
                                                                              ) {
                                                                                return _vm.onlyNumbers(
                                                                                  event
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                beneficiario.nroDocumento,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  beneficiario,
                                                                                  "nroDocumento",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "beneficiario.nroDocumento"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                beneficiario.metodoPago !==
                                                                  "Pago en ventanilla Interbank" &&
                                                                _vm.mostrarTransferencia
                                                                  ? _c(
                                                                      "v-layout",
                                                                      {
                                                                        staticClass:
                                                                          "row-mp-data",
                                                                        attrs: {
                                                                          id:
                                                                            "bancos"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          {
                                                                            staticClass:
                                                                              "select-box",
                                                                            attrs: {
                                                                              solo:
                                                                                "solo",
                                                                              items:
                                                                                _vm.bancos,
                                                                              label:
                                                                                "Banco",
                                                                              "prepend-inner-icon":
                                                                                "help",
                                                                              required:
                                                                                "required",
                                                                              "menu-props":
                                                                                _vm.selectMenuProps
                                                                            },
                                                                            nativeOn: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return function(
                                                                                  event
                                                                                ) {
                                                                                  return _vm.showDialogBank(
                                                                                    event
                                                                                  )
                                                                                }.apply(
                                                                                  null,
                                                                                  arguments
                                                                                )
                                                                              }
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                beneficiario.banco,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  beneficiario,
                                                                                  "banco",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "beneficiario.banco"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                beneficiario.metodoPago !==
                                                                  "Pago en ventanilla Interbank" &&
                                                                _vm.mostrarTransferencia
                                                                  ? _c(
                                                                      "v-layout",
                                                                      {
                                                                        staticClass:
                                                                          "row-mp-data"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          {
                                                                            staticClass:
                                                                              "select-box",
                                                                            attrs: {
                                                                              solo:
                                                                                "solo",
                                                                              items:
                                                                                _vm.monedas,
                                                                              label:
                                                                                "Moneda",
                                                                              disabled: [
                                                                                "soat",
                                                                                "protección tarjeta"
                                                                              ].includes(
                                                                                _vm.form.tipoPoliza.toLowerCase()
                                                                              ),
                                                                              "menu-props":
                                                                                _vm.selectMenuProps
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                beneficiario.moneda,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  beneficiario,
                                                                                  "moneda",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "beneficiario.moneda"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                beneficiario.metodoPago !==
                                                                  "Pago en ventanilla Interbank" &&
                                                                _vm.mostrarTransferencia
                                                                  ? _c(
                                                                      "v-layout",
                                                                      {
                                                                        staticClass:
                                                                          "row-mp-data"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-select",
                                                                          {
                                                                            staticClass:
                                                                              "select-box",
                                                                            attrs: {
                                                                              solo:
                                                                                "solo",
                                                                              items:
                                                                                _vm.tiposCuenta,
                                                                              label:
                                                                                "Tipo de cuenta",
                                                                              required:
                                                                                "required",
                                                                              "menu-props":
                                                                                _vm.selectMenuProps
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                beneficiario.tipoCuenta,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  beneficiario,
                                                                                  "tipoCuenta",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "beneficiario.tipoCuenta"
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _c(
                                                                  "v-layout",
                                                                  {
                                                                    staticClass:
                                                                      "row-mp-data",
                                                                    staticStyle: {
                                                                      "margin-top":
                                                                        "20px",
                                                                      "justify-content":
                                                                        "space-between"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "btn-solicitud btn-pink omnesSemibold",
                                                                        staticStyle: {
                                                                          width:
                                                                            "40%",
                                                                          height:
                                                                            "50px"
                                                                        },
                                                                        attrs: {
                                                                          type:
                                                                            "button"
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.beneficiarioRemove(
                                                                              index
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Cancelar"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "btn-solicitud btn-blue omnesSemibold",
                                                                        staticStyle: {
                                                                          width:
                                                                            "40%",
                                                                          height:
                                                                            "50px"
                                                                        },
                                                                        attrs: {
                                                                          type:
                                                                            "button",
                                                                          disabled: _vm.isDisabledBtnContinue()
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.beneficiarioAddEdit(
                                                                              index,
                                                                              beneficiario
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Continuar"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                !_vm.beneficiarioOpened &&
                                                _vm.getBeneficiarioDisponible()
                                                  ? _c(
                                                      "v-layout",
                                                      {
                                                        staticClass:
                                                          "row-mp-data",
                                                        staticStyle: {
                                                          margin: "0 15px"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "plus-icon",
                                                            attrs: {
                                                              id:
                                                                "agregar-beneficiario"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.beneficiarioEditarComprimir()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", [
                                                              _c(
                                                                "svg",
                                                                {
                                                                  attrs: {
                                                                    width: "16",
                                                                    height:
                                                                      "16",
                                                                    viewbox:
                                                                      "2 2 32 16",
                                                                    fill:
                                                                      "#FFFFFF",
                                                                    xmlns:
                                                                      "http://www.w3.org/2000/svg"
                                                                  }
                                                                },
                                                                [
                                                                  _c("path", {
                                                                    attrs: {
                                                                      "fill-rule":
                                                                        "evenodd",
                                                                      d:
                                                                        "M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z",
                                                                      "clip-rule":
                                                                        "evenodd"
                                                                    }
                                                                  }),
                                                                  _c("path", {
                                                                    attrs: {
                                                                      "fill-rule":
                                                                        "evenodd",
                                                                      d:
                                                                        "M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z",
                                                                      "clip-rule":
                                                                        "evenodd"
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "Ingresar cuenta bancaria de un beneficiario"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.sectionBotonesDatos &&
                                !_vm.beneficiarioOpened
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "section-botones-solicitud"
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "row-mp-data",
                                            staticStyle: {
                                              "margin-top": "20px",
                                              "justify-content": "space-between"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "btn-solicitud btn-pink omnesSemibold",
                                                staticStyle: {
                                                  width: "40%",
                                                  height: "50px"
                                                },
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goToHome()
                                                  }
                                                }
                                              },
                                              [_vm._v("Cancelar")]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "btn-solicitud btn-blue omnesSemibold",
                                                staticStyle: {
                                                  width: "40%",
                                                  height: "50px"
                                                },
                                                attrs: {
                                                  type: "button",
                                                  disabled: !_vm.validateForm()
                                                },
                                                on: { click: _vm.nextStep }
                                              },
                                              [_vm._v("Continuar")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.sectionDocumentos
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "view_myproduct",
                          attrs: {
                            xs0: "xs0",
                            sm0: "sm0",
                            md5: "md5",
                            lg4: "lg4"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            [
                              _vm.sectionDocumentos
                                ? _c(
                                    "v-flex",
                                    { staticClass: "myproduct document-loads" },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "omnesMedium mp-title only-desktop"
                                        },
                                        [_vm._v("Documentos")]
                                      ),
                                      _vm.sectionSolicitante
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-solicitud-datos"
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  staticClass:
                                                    "row-mp-subtitle",
                                                  style: _vm.solicitanteComprimido
                                                    ? {
                                                        "border-bottom":
                                                          "1px solid #E7EAED"
                                                      }
                                                    : {}
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { lg12: "lg12" } },
                                                    [
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "omnesRegular mp-subtitle"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              (this.validateSoatVida()
                                                                ? "5."
                                                                : "4.") +
                                                                " Carga de documentos"
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "section-data-content section-document-loads"
                                                },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass: "row-mp-data"
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v(
                                                          "Adjunta los documentos para evaluar tu solicitud."
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass: "row-mp-data"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "box-blue-rounded"
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                "Formatos permitidos: PDF, JPEG o PNG. Cada uno con un peso máximo de " +
                                                                  _vm.sizeText +
                                                                  "MB."
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass: "row-mp-data"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "10px",
                                                            "margin-right":
                                                              "10px",
                                                            "margin-top":
                                                              "-5px",
                                                            "font-size": "12px",
                                                            "line-height":
                                                              "15px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              "Agrega un total de " +
                                                                (_vm.validateSoatVida()
                                                                  ? "4"
                                                                  : "5") +
                                                                " documentos " +
                                                                (_vm.validateSoatVida()
                                                                  ? "extra"
                                                                  : "") +
                                                                " que apoyen a la evaluación de la solicitud de ser necesario."
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  !_vm.validateSoatVidaProteccion()
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _vm._l(
                                                            _vm.files,
                                                            function(
                                                              file,
                                                              indexF
                                                            ) {
                                                              return _c(
                                                                "v-layout",
                                                                {
                                                                  key:
                                                                    "document-" +
                                                                    indexF,
                                                                  staticClass:
                                                                    "row-mp-subtitle",
                                                                  staticStyle: {
                                                                    "margin-top":
                                                                      "-10px"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      staticClass:
                                                                        "col-mp-button",
                                                                      attrs: {
                                                                        lg1:
                                                                          "lg1"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticStyle: {
                                                                            width:
                                                                              "15px"
                                                                          },
                                                                          attrs: {
                                                                            id:
                                                                              "attachments-release",
                                                                            src:
                                                                              _vm
                                                                                .images
                                                                                .iconDoc
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      staticStyle: {
                                                                        margin:
                                                                          "0px",
                                                                        "padding-left":
                                                                          "10px",
                                                                        height:
                                                                          "30px"
                                                                      },
                                                                      attrs: {
                                                                        lg10:
                                                                          "lg10"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "row"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "box-blue-rounded-file",
                                                                              staticStyle: {
                                                                                "margin-left":
                                                                                  "20px"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticStyle: {
                                                                                    "white-space":
                                                                                      "nowrap",
                                                                                    overflow:
                                                                                      "hidden",
                                                                                    "text-overflow":
                                                                                      "ellipsis",
                                                                                    "max-width":
                                                                                      "150px"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      file.name
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      staticClass:
                                                                        "col-mp-button",
                                                                      staticStyle: {
                                                                        display:
                                                                          "flex",
                                                                        "align-items":
                                                                          "center",
                                                                        "justify-content":
                                                                          "center"
                                                                      },
                                                                      attrs: {
                                                                        lg1:
                                                                          "lg1"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticStyle: {
                                                                            cursor:
                                                                              "pointer",
                                                                            width:
                                                                              "25px"
                                                                          },
                                                                          attrs: {
                                                                            id:
                                                                              "attachments-release",
                                                                            src:
                                                                              _vm
                                                                                .images
                                                                                .iconClose
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.removeExtraFile(
                                                                                file.name,
                                                                                indexF
                                                                              )
                                                                            }
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          _vm.files.length <
                                                          (this.validateSoatVidaProteccion()
                                                            ? 4
                                                            : 5)
                                                            ? _c(
                                                                "v-layout",
                                                                {
                                                                  staticClass:
                                                                    "row-mp-subtitle",
                                                                  staticStyle: {
                                                                    "margin-top":
                                                                      "-10px",
                                                                    "margin-bottom":
                                                                      "0"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "plus-icon2",
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.uploadExtraFile()
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c("i", [
                                                                        _c(
                                                                          "svg",
                                                                          {
                                                                            attrs: {
                                                                              width:
                                                                                "16",
                                                                              height:
                                                                                "16",
                                                                              viewbox:
                                                                                "2 2 32 16",
                                                                              fill:
                                                                                "#454A6C",
                                                                              xmlns:
                                                                                "http://www.w3.org/2000/svg"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs: {
                                                                                  "fill-rule":
                                                                                    "evenodd",
                                                                                  d:
                                                                                    "M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z",
                                                                                  "clip-rule":
                                                                                    "evenodd"
                                                                                }
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs: {
                                                                                  "fill-rule":
                                                                                    "evenodd",
                                                                                  d:
                                                                                    "M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z",
                                                                                  "clip-rule":
                                                                                    "evenodd"
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        "Subir archivo."
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                  _vm._l(_vm.files, function(
                                                    cobertura,
                                                    indexC
                                                  ) {
                                                    return _vm.validateSoatVidaProteccion()
                                                      ? _c(
                                                          "div",
                                                          { key: indexC },
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                staticClass:
                                                                  "row-mp-data"
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticStyle: {
                                                                      margin:
                                                                        "10px 0px 20px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        cobertura.name
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._l(
                                                              cobertura.documents,
                                                              function(
                                                                doc,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "v-layout",
                                                                  {
                                                                    key:
                                                                      "doc-" +
                                                                      index,
                                                                    staticClass:
                                                                      "row-mp-subtitle",
                                                                    staticStyle: {
                                                                      "border-bottom":
                                                                        "1px solid #E7EAED",
                                                                      "margin-top":
                                                                        "-7px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        staticClass:
                                                                          "col-mp-button",
                                                                        staticStyle: {
                                                                          display:
                                                                            "flex",
                                                                          "align-items":
                                                                            "flex-start",
                                                                          "justify-content":
                                                                            "flex-start"
                                                                        },
                                                                        attrs: {
                                                                          lg1:
                                                                            "lg1"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticStyle: {
                                                                              width:
                                                                                "15px"
                                                                            },
                                                                            attrs: {
                                                                              id:
                                                                                "attachments-release",
                                                                              src:
                                                                                _vm
                                                                                  .images
                                                                                  .iconDoc
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        staticStyle: {
                                                                          margin:
                                                                            "0px",
                                                                          "padding-left":
                                                                            "10px",
                                                                          height:
                                                                            "55px"
                                                                        },
                                                                        attrs: {
                                                                          lg10:
                                                                            "lg10"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "row"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "h4",
                                                                              {
                                                                                staticClass:
                                                                                  "omnesRegular mp-subtitle"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    doc.name
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        doc.uploaded
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "row"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "box-blue-rounded-file"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "p",
                                                                                      {
                                                                                        staticStyle: {
                                                                                          "white-space":
                                                                                            "nowrap",
                                                                                          overflow:
                                                                                            "hidden",
                                                                                          "text-overflow":
                                                                                            "ellipsis",
                                                                                          "max-width":
                                                                                            "150px"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            doc.filename
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        staticClass:
                                                                          "col-mp-button",
                                                                        staticStyle: {
                                                                          display:
                                                                            "flex",
                                                                          "align-items":
                                                                            "center",
                                                                          "justify-content":
                                                                            "center"
                                                                        },
                                                                        attrs: {
                                                                          lg1:
                                                                            "lg1"
                                                                        }
                                                                      },
                                                                      [
                                                                        !doc.uploaded
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticStyle: {
                                                                                  cursor:
                                                                                    "pointer",
                                                                                  width:
                                                                                    "25px"
                                                                                },
                                                                                attrs: {
                                                                                  id:
                                                                                    "attachments-release",
                                                                                  src:
                                                                                    _vm
                                                                                      .images
                                                                                      .iconCloud
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.uploadFile(
                                                                                      cobertura.name,
                                                                                      doc.name
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          : _vm._e(),
                                                                        doc.uploaded
                                                                          ? _c(
                                                                              "img",
                                                                              {
                                                                                staticStyle: {
                                                                                  cursor:
                                                                                    "pointer",
                                                                                  width:
                                                                                    "25px"
                                                                                },
                                                                                attrs: {
                                                                                  id:
                                                                                    "attachments-release",
                                                                                  src:
                                                                                    _vm
                                                                                      .images
                                                                                      .iconClose
                                                                                },
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.removeFile(
                                                                                      cobertura.name,
                                                                                      doc.name
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            _vm._l(
                                                              cobertura.additional,
                                                              function(
                                                                add,
                                                                indexA
                                                              ) {
                                                                return _c(
                                                                  "v-layout",
                                                                  {
                                                                    key:
                                                                      "additional-" +
                                                                      indexA,
                                                                    staticClass:
                                                                      "row-mp-subtitle",
                                                                    staticStyle: {
                                                                      "margin-top":
                                                                        "-10px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        staticClass:
                                                                          "col-mp-button",
                                                                        attrs: {
                                                                          lg1:
                                                                            "lg1"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticStyle: {
                                                                              width:
                                                                                "15px"
                                                                            },
                                                                            attrs: {
                                                                              id:
                                                                                "attachments-release",
                                                                              src:
                                                                                _vm
                                                                                  .images
                                                                                  .iconDoc
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        staticStyle: {
                                                                          margin:
                                                                            "0px",
                                                                          "padding-left":
                                                                            "10px",
                                                                          height:
                                                                            "30px"
                                                                        },
                                                                        attrs: {
                                                                          lg10:
                                                                            "lg10"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "row"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "box-blue-rounded-file",
                                                                                staticStyle: {
                                                                                  "margin-left":
                                                                                    "20px"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      "white-space":
                                                                                        "nowrap",
                                                                                      overflow:
                                                                                        "hidden",
                                                                                      "text-overflow":
                                                                                        "ellipsis",
                                                                                      "max-width":
                                                                                        "150px"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        add.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-flex",
                                                                      {
                                                                        staticClass:
                                                                          "col-mp-button",
                                                                        staticStyle: {
                                                                          display:
                                                                            "flex",
                                                                          "align-items":
                                                                            "center",
                                                                          "justify-content":
                                                                            "center"
                                                                        },
                                                                        attrs: {
                                                                          lg1:
                                                                            "lg1"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "img",
                                                                          {
                                                                            staticStyle: {
                                                                              cursor:
                                                                                "pointer",
                                                                              width:
                                                                                "25px"
                                                                            },
                                                                            attrs: {
                                                                              id:
                                                                                "attachments-release",
                                                                              src:
                                                                                _vm
                                                                                  .images
                                                                                  .iconClose
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.removeExtraFile(
                                                                                  cobertura.name,
                                                                                  indexA
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            (cobertura
                                                              .additional
                                                              .length <
                                                            _vm.validateSoatVida()
                                                            ? 4
                                                            : 5)
                                                              ? _c(
                                                                  "v-layout",
                                                                  {
                                                                    staticClass:
                                                                      "row-mp-subtitle",
                                                                    staticStyle: {
                                                                      "margin-top":
                                                                        "-10px",
                                                                      "margin-bottom":
                                                                        "0"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "plus-icon2",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.uploadExtraFile(
                                                                              cobertura.name
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          [
                                                                            _c(
                                                                              "svg",
                                                                              {
                                                                                attrs: {
                                                                                  width:
                                                                                    "16",
                                                                                  height:
                                                                                    "16",
                                                                                  viewbox:
                                                                                    "2 2 32 16",
                                                                                  fill:
                                                                                    "#454A6C",
                                                                                  xmlns:
                                                                                    "http://www.w3.org/2000/svg"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "path",
                                                                                  {
                                                                                    attrs: {
                                                                                      "fill-rule":
                                                                                        "evenodd",
                                                                                      d:
                                                                                        "M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z",
                                                                                      "clip-rule":
                                                                                        "evenodd"
                                                                                    }
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "path",
                                                                                  {
                                                                                    attrs: {
                                                                                      "fill-rule":
                                                                                        "evenodd",
                                                                                      d:
                                                                                        "M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z",
                                                                                      "clip-rule":
                                                                                        "evenodd"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "Subir archivo extra."
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e()
                                                  }),
                                                  _c("input", {
                                                    ref: "filesInput",
                                                    staticClass: "uploadFile",
                                                    staticStyle: {
                                                      display: "none"
                                                    },
                                                    attrs: {
                                                      id: "inputfile",
                                                      type: "file",
                                                      name: "filename",
                                                      accept:
                                                        "image/*,application/pdf"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.previewFile(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c("input", {
                                                    ref: "extraFilesInput",
                                                    staticClass: "uploadFile",
                                                    staticStyle: {
                                                      display: "none"
                                                    },
                                                    attrs: {
                                                      id: "inputfile",
                                                      type: "file",
                                                      name: "filename",
                                                      accept:
                                                        "image/*,application/pdf"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.previewExtraFile(
                                                          $event
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "row-mp-data",
                                                      staticStyle: {
                                                        "margin-top": "0px"
                                                      }
                                                    },
                                                    [
                                                      _c("ul", [
                                                        _c(
                                                          "li",
                                                          {
                                                            staticClass:
                                                              "conditions-policy"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Al continuar acepto las  "
                                                            ),
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "https://www.interseguro.pe/wp-content/uploads/2020/09/Poli%CC%81tica%20de%20Privacidad%20Interseguro.pdf",
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "condiciones de uso y políticas de privacidad."
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      staticClass:
                                                        "row-mp-data",
                                                      staticStyle: {
                                                        "margin-top": "0px"
                                                      }
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function() {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: _vm.selectedInsuredCopy
                                                                        ? "checked"
                                                                        : "unchecked",
                                                                      staticStyle: {
                                                                        "font-size":
                                                                          "13px",
                                                                        "line-height":
                                                                          "14px"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Acepto el  tratamiento de los datos personales."
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              },
                                                              proxy: true
                                                            }
                                                          ],
                                                          null,
                                                          false,
                                                          3833050917
                                                        ),
                                                        model: {
                                                          value:
                                                            _vm.selectedDataPolicy,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.selectedDataPolicy = $$v
                                                          },
                                                          expression:
                                                            "selectedDataPolicy"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm.form.tipoPoliza.toLowerCase() ===
                                                  "protección tarjeta"
                                                    ? _c(
                                                        "v-layout",
                                                        {
                                                          staticClass:
                                                            "row-mp-data",
                                                          staticStyle: {
                                                            "margin-top":
                                                              "-40px"
                                                          }
                                                        },
                                                        [
                                                          _c("v-checkbox", {
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "label",
                                                                  fn: function() {
                                                                    return [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "selected-insured-copy",
                                                                          class: _vm
                                                                            .form
                                                                            .declaracionJurada
                                                                            ? "checked"
                                                                            : "unchecked",
                                                                          staticStyle: {
                                                                            "font-size":
                                                                              "13px",
                                                                            "line-height":
                                                                              "14px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Acepto el intercambio de mis datos en el sistema financiero"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  },
                                                                  proxy: true
                                                                }
                                                              ],
                                                              null,
                                                              false,
                                                              1419530535
                                                            ),
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .declaracionJurada,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "declaracionJurada",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.declaracionJurada"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.sectionBotonesDocumentos &&
                                      !_vm.beneficiarioOpened
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "section-botones-solicitud"
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  staticClass: "row-mp-data",
                                                  staticStyle: {
                                                    "margin-top": "20px",
                                                    "justify-content":
                                                      "space-between"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "btn-solicitud btn-pink omnesSemibold",
                                                      staticStyle: {
                                                        width: "40%",
                                                        height: "50px"
                                                      },
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.goToHome()
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Cancelar")]
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "btn-solicitud btn-blue omnesSemibold",
                                                      staticStyle: {
                                                        width: "40%",
                                                        height: "50px"
                                                      },
                                                      attrs: {
                                                        type: "button",
                                                        disabled: !_vm.validateForm()
                                                      },
                                                      on: {
                                                        click: _vm.nextStep
                                                      }
                                                    },
                                                    [_vm._v("Continuar")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.sectionResumen
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "view_myproduct",
                          attrs: {
                            xs0: "xs0",
                            sm0: "sm0",
                            md5: "md5",
                            lg4: "lg4"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            [
                              _vm.sectionResumen
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "myproduct",
                                      staticStyle: { padding: "10px" }
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "omnesMedium mp-title justify-center",
                                          staticStyle: {
                                            padding: "0 10px 10px 0",
                                            "text-align": "center"
                                          }
                                        },
                                        [_vm._v("Resumen de Solicitud")]
                                      ),
                                      _c(
                                        "v-layout",
                                        { staticClass: "resumen-data" },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "xs12",
                                                sm12: "sm12",
                                                md12: "md12",
                                                lg12: "lg12"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs6: "xs6",
                                                        sm6: "sm6",
                                                        md6: "md6",
                                                        lg6: "lg6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "label-resumen"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Datos del " +
                                                              _vm._s(
                                                                _vm.form.tipoPoliza.toLowerCase() ===
                                                                  "soat"
                                                                  ? "lesionado"
                                                                  : "asegurado"
                                                              ) +
                                                              ":"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "right"
                                                      },
                                                      attrs: {
                                                        xs6: "xs6",
                                                        sm6: "sm6",
                                                        md6: "md6",
                                                        lg6: "lg6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-resumen"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.form.asegurado.nombres.split(
                                                                " "
                                                              )[0] +
                                                                " " +
                                                                _vm.form
                                                                  .asegurado
                                                                  .apellidoPaterno
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs6: "xs6",
                                                        sm6: "sm6",
                                                        md6: "md6",
                                                        lg6: "lg6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "label-resumen"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Datos del solicitante:"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "right"
                                                      },
                                                      attrs: {
                                                        xs6: "xs6",
                                                        sm6: "sm6",
                                                        md6: "md6",
                                                        lg6: "lg6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-resumen"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.form.solicitante.nombres.split(
                                                                " "
                                                              )[0] +
                                                                " " +
                                                                _vm.form
                                                                  .solicitante
                                                                  .apellidoPaterno
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.validateSoatVidaProteccion()
                                                ? _c(
                                                    "v-layout",
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          attrs: {
                                                            xs6: "xs6",
                                                            sm6: "sm6",
                                                            md6: "md6",
                                                            lg6: "lg6"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "label-resumen"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Método de pago:"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticStyle: {
                                                            "text-align":
                                                              "right"
                                                          },
                                                          attrs: {
                                                            xs6: "xs6",
                                                            sm6: "sm6",
                                                            md6: "md6",
                                                            lg6: "lg6"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "text-resumen"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getMetodoPago()
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c("v-layout", [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "omnesMedium mp-title",
                                                    staticStyle: {
                                                      "text-decoration":
                                                        "underline",
                                                      "border-bottom": "none",
                                                      padding: "0 10px 10px 0"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Coberturas solicitadas:"
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs6: "xs6",
                                                        sm6: "sm6",
                                                        md6: "md6",
                                                        lg6: "lg6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "label-resumen"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Documentos adjuntos:"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "right"
                                                      },
                                                      attrs: {
                                                        xs6: "xs6",
                                                        sm6: "sm6",
                                                        md6: "md6",
                                                        lg6: "lg6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-resumen"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.countDocuments()
                                                            ) + "   documentos"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._l(_vm.files, function(
                                                cobertura,
                                                indexC
                                              ) {
                                                return _vm.validateSoatVida()
                                                  ? _c(
                                                      "div",
                                                      {
                                                        key: indexC,
                                                        style:
                                                          indexC <
                                                          _vm.files.length - 1
                                                            ? "border-bottom: 1px solid #E7EAED;"
                                                            : ""
                                                      },
                                                      [
                                                        _vm._l(
                                                          cobertura.documents,
                                                          function(
                                                            document,
                                                            indexD
                                                          ) {
                                                            return _c(
                                                              "v-layout",
                                                              {
                                                                key:
                                                                  "documents-" +
                                                                  indexD,
                                                                attrs: {
                                                                  id:
                                                                    "documents-" +
                                                                    indexD
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      xs6:
                                                                        "xs6",
                                                                      sm6:
                                                                        "sm6",
                                                                      md6:
                                                                        "md6",
                                                                      lg6: "lg6"
                                                                    }
                                                                  },
                                                                  [
                                                                    indexD === 0
                                                                      ? _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "label-resumen"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                cobertura.name
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    staticStyle: {
                                                                      "text-align":
                                                                        "right"
                                                                    },
                                                                    attrs: {
                                                                      xs6:
                                                                        "xs6",
                                                                      sm6:
                                                                        "sm6",
                                                                      md6:
                                                                        "md6",
                                                                      lg6: "lg6"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "text-resumen",
                                                                        staticStyle: {
                                                                          "white-space":
                                                                            "nowrap",
                                                                          overflow:
                                                                            "hidden",
                                                                          "text-overflow":
                                                                            "ellipsis"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            document.filename
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        _vm._l(
                                                          cobertura.additional,
                                                          function(
                                                            document,
                                                            indexA
                                                          ) {
                                                            return _c(
                                                              "v-layout",
                                                              {
                                                                key:
                                                                  "additional-" +
                                                                  indexA,
                                                                attrs: {
                                                                  id:
                                                                    "additional-" +
                                                                    indexA
                                                                }
                                                              },
                                                              [
                                                                _c("v-flex", {
                                                                  attrs: {
                                                                    xs6: "xs6",
                                                                    sm6: "sm6",
                                                                    md6: "md6",
                                                                    lg6: "lg6"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    staticStyle: {
                                                                      "text-align":
                                                                        "right"
                                                                    },
                                                                    attrs: {
                                                                      xs6:
                                                                        "xs6",
                                                                      sm6:
                                                                        "sm6",
                                                                      md6:
                                                                        "md6",
                                                                      lg6: "lg6"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "text-resumen",
                                                                        staticStyle: {
                                                                          "white-space":
                                                                            "nowrap",
                                                                          overflow:
                                                                            "hidden",
                                                                          "text-overflow":
                                                                            "ellipsis"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            document.name
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _c(
                                                      "div",
                                                      _vm._l(
                                                        _vm.getFiles(),
                                                        function(
                                                          document,
                                                          indexFiles
                                                        ) {
                                                          return _c(
                                                            "v-layout",
                                                            {
                                                              key:
                                                                "files-" +
                                                                indexFiles,
                                                              staticClass:
                                                                "test",
                                                              attrs: {
                                                                id:
                                                                  "files-" +
                                                                  indexFiles
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  staticStyle: {
                                                                    "text-align":
                                                                      "right"
                                                                  },
                                                                  attrs: {
                                                                    xs12:
                                                                      "xs12",
                                                                    sm12:
                                                                      "sm12",
                                                                    md12:
                                                                      "md12",
                                                                    lg12: "lg12"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "text-resumen",
                                                                      staticStyle: {
                                                                        "white-space":
                                                                          "nowrap",
                                                                        overflow:
                                                                          "hidden",
                                                                        "text-overflow":
                                                                          "ellipsis"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          document.name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                              }),
                                              _c(
                                                "v-layout",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "10px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs6: "xs6",
                                                        sm6: "sm6",
                                                        md6: "md6",
                                                        lg6: "lg6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "label-resumen"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Fecha de solicitud:"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "right"
                                                      },
                                                      attrs: {
                                                        xs6: "xs6",
                                                        sm6: "sm6",
                                                        md6: "md6",
                                                        lg6: "lg6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-resumen"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              new Date().toLocaleDateString(
                                                                "es-ES",
                                                                {
                                                                  day:
                                                                    "2-digit",
                                                                  month:
                                                                    "2-digit",
                                                                  year:
                                                                    "numeric"
                                                                }
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "section-botones-solicitud"
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: {
                                                "margin-top": "20px"
                                              },
                                              attrs: {
                                                row: "row",
                                                wrap: "wrap",
                                                "justify-center":
                                                  "justify-center"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "btn-solicitud btn-pink-filled omnesSemibold",
                                                  staticStyle: {
                                                    width: "40%",
                                                    height: "50px"
                                                  },
                                                  attrs: {
                                                    type: "button",
                                                    disabled: !_vm.validateForm()
                                                  },
                                                  on: { click: _vm.nextStep }
                                                },
                                                [_vm._v("Registrar solicitud")]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: {
                                                "margin-top": "20px"
                                              },
                                              attrs: {
                                                row: "row",
                                                wrap: "wrap",
                                                "justify-center":
                                                  "justify-center"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "btn-volver",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goBack()
                                                    }
                                                  }
                                                },
                                                [_vm._v("Volver")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.sectionFinal
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "view_myproduct",
                          attrs: {
                            xs0: "xs0",
                            sm0: "sm0",
                            md5: "md5",
                            lg4: "lg4"
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            [
                              _vm.sectionFinal
                                ? _c(
                                    "v-flex",
                                    {
                                      staticClass: "myproduct",
                                      staticStyle: { padding: "20px" }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "g-flex justify-center"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "justify-center",
                                                attrs: {
                                                  src: _vm.images.iconSuccess
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "h3",
                                        {
                                          staticClass:
                                            "omnesMedium mp-title justify-center",
                                          staticStyle: {
                                            border: "none",
                                            "text-align": "center"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "¡Solicitud ingresada con éxito!"
                                          )
                                        ]
                                      ),
                                      _c(
                                        "v-layout",
                                        { staticClass: "resumen-data" },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "xs12",
                                                sm12: "sm12",
                                                md12: "md12",
                                                lg12: "lg12"
                                              }
                                            },
                                            [
                                              _c("v-layout", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "omnesRegular justify-center",
                                                    staticStyle: {
                                                      width: "100%",
                                                      padding: "10px",
                                                      "text-align": "center"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "La respuesta de tu solicitud "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " N° " +
                                                        _vm._s(_vm.nroCaso) +
                                                        " "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " será enviada a tu correo electrónico "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " en un tiempo aproximado de " +
                                                        _vm._s(
                                                          _vm.responseRequestTwoDays
                                                            ? "2"
                                                            : "8"
                                                        ) +
                                                        " días."
                                                    )
                                                  ]
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "section-botones-solicitud"
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: {
                                                "margin-top": "10px"
                                              },
                                              attrs: {
                                                row: "row",
                                                wrap: "wrap",
                                                "justify-center":
                                                  "justify-center"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "btn-solicitud btn-pink-filled omnesSemibold",
                                                  staticStyle: {
                                                    width: "70%",
                                                    height: "50px"
                                                  },
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goToHome()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Volver al menú principal"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          this.isPhase2
                                            ? _c(
                                                "v-layout",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "10px"
                                                  },
                                                  attrs: {
                                                    row: "row",
                                                    wrap: "wrap",
                                                    "justify-center":
                                                      "justify-center"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "btn-solicitud btn-blue omnesSemibold",
                                                      staticStyle: {
                                                        width: "70%",
                                                        height: "50px"
                                                      },
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.goToHome()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Seguimiento de la solicitud"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: {
                                                "margin-top": "20px"
                                              },
                                              attrs: {
                                                row: "row",
                                                wrap: "wrap",
                                                "justify-center":
                                                  "justify-center"
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    "font-style": "normal",
                                                    "font-weight": "400",
                                                    "font-size": "12px",
                                                    "line-height": "13px",
                                                    "letter-spacing": "0.005em",
                                                    color: "#454A6C",
                                                    padding: "20px",
                                                    "text-align": "justify"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "La aceptación del registro no implica la aprobación del siniestro ni la presentación completa de los requisitos mínimos obligatorios."
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.sectionConsulta
        ? _c("div", { attrs: { id: "section-consulta" } }, [
            _c(
              "div",
              { staticClass: "section-content" },
              [
                _c("h2", [_vm._v("Consulta el estado de tu solicitud")]),
                _c(
                  "v-layout",
                  {
                    staticStyle: {
                      "margin-top": "10px",
                      "margin-bottom": "25px"
                    },
                    attrs: {
                      row: "row",
                      wrap: "wrap",
                      "justify-center": "justify-center"
                    }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          width: "80%",
                          padding: "0 2rem",
                          "text-align": "center"
                        }
                      },
                      [
                        _vm._v(
                          "Ingresa el número de solicitud enviado a tu correo electrónico"
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "v-layout",
                  {
                    staticStyle: { "margin-bottom": "40px" },
                    attrs: {
                      row: "row",
                      wrap: "wrap",
                      "justify-center": "justify-center"
                    }
                  },
                  [
                    _vm.sectionConsulta
                      ? _c(
                          "v-flex",
                          {
                            staticClass: "container",
                            attrs: {
                              xs0: "xs0",
                              sm0: "sm0",
                              md4: "md4",
                              lg4: "lg4"
                            }
                          },
                          [
                            _c(
                              "v-layout",
                              {
                                staticStyle: {
                                  width: "70%",
                                  margin: "auto",
                                  "margin-bottom": "80px"
                                },
                                attrs: {
                                  row: "row",
                                  wrap: "wrap",
                                  "justify-center": "justify-center"
                                }
                              },
                              [
                                _c(
                                  "v-layout",
                                  { staticClass: "row-mp-data" },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Número de solicitud",
                                        outline: "outline"
                                      },
                                      model: {
                                        value: _vm.caseId,
                                        callback: function($$v) {
                                          _vm.caseId = $$v
                                        },
                                        expression: "caseId"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-layout",
                              {
                                attrs: {
                                  row: "row",
                                  wrap: "wrap",
                                  "justify-center": "justify-center"
                                }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "btn-solicitud btn-pink-filled omnesSemibold",
                                    staticStyle: { height: "50px" },
                                    attrs: {
                                      id: "btn-coverages",
                                      type: "button",
                                      disabled: _vm.caseId.length < 8
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.querySinister()
                                      }
                                    }
                                  },
                                  [_vm._v("Siguiente")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-layout",
                              {
                                staticStyle: { "margin-top": "20px" },
                                attrs: {
                                  row: "row",
                                  wrap: "wrap",
                                  "justify-center": "justify-center"
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn-volver",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToHome()
                                      }
                                    }
                                  },
                                  [_vm._v("Volver")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.sectionResultado
        ? _c("div", { attrs: { id: "section-consulta" } }, [
            _c(
              "div",
              { staticClass: "section-content" },
              [
                _c("h2", [_vm._v("Estado de tu solicitud")]),
                _c(
                  "v-layout",
                  {
                    staticStyle: { "margin-bottom": "40px" },
                    attrs: {
                      row: "row",
                      wrap: "wrap",
                      "justify-center": "justify-center"
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      {
                        staticClass: "container",
                        attrs: {
                          xs0: "xs0",
                          sm0: "sm0",
                          md4: "md4",
                          lg4: "lg4"
                        }
                      },
                      [
                        _c(
                          "v-layout",
                          { staticClass: "resumen-data" },
                          [
                            _c(
                              "v-flex",
                              {
                                staticStyle: { margin: "auto" },
                                attrs: {
                                  xs10: "xs10",
                                  sm10: "sm10",
                                  md10: "md10",
                                  lg10: "lg10"
                                }
                              },
                              [
                                _c("v-layout", [
                                  _c(
                                    "div",
                                    { staticClass: "progress-bar-component" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "progress-bar-container"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "progress-bar" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  style:
                                                    _vm.sinisterCase.value || 0
                                                      ? "color: #0855C4"
                                                      : ""
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.sinisterCase.value ||
                                                        0
                                                    ) + " %"
                                                  )
                                                ]
                                              ),
                                              _c("div", {
                                                staticClass: "progress",
                                                style:
                                                  "width: " +
                                                  (_vm.sinisterCase.value ||
                                                    0) +
                                                  "%"
                                              }),
                                              _c("div", {
                                                staticClass: "marker",
                                                style:
                                                  "top: -7px; left: calc(" +
                                                  (_vm.sinisterCase.value ||
                                                    0) +
                                                  "% - 5px);"
                                              }),
                                              _vm.caseStatus !== "rechazado" &&
                                              (_vm.sinisterCase.value || 0) ===
                                                100
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#0855C4",
                                                        top: "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Solicitud respondida"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _c(
                                  "v-layout",
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs6: "xs6",
                                          sm6: "sm6",
                                          md6: "md6",
                                          lg6: "lg6"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "label-resumen" },
                                          [_vm._v("Estado de Solicitud:")]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        staticStyle: { "text-align": "right" },
                                        attrs: {
                                          xs6: "xs6",
                                          sm6: "sm6",
                                          md6: "md6",
                                          lg6: "lg6"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "text-resumen" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "button-decoration",
                                                class: _vm.caseStatus
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.sinisterCase.status
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs6: "xs6",
                                          sm6: "sm6",
                                          md6: "md6",
                                          lg6: "lg6"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "label-resumen" },
                                          [_vm._v("Fecha de solicitud:")]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        staticStyle: { "text-align": "right" },
                                        attrs: {
                                          xs6: "xs6",
                                          sm6: "sm6",
                                          md6: "md6",
                                          lg6: "lg6"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "text-resumen" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.sinisterCase.date)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs6: "xs6",
                                          sm6: "sm6",
                                          md6: "md6",
                                          lg6: "lg6"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "label-resumen" },
                                          [
                                            _vm._v(
                                              "Fecha tentativa de respuesta:"
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "v-flex",
                                      {
                                        staticStyle: { "text-align": "right" },
                                        attrs: {
                                          xs6: "xs6",
                                          sm6: "sm6",
                                          md6: "md6",
                                          lg6: "lg6"
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "text-resumen" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.sinisterCase.dateResponse
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm.caseStatus !== "pendiente" &&
                                _vm.caseStatus !== "evaluacion"
                                  ? _c(
                                      "v-layout",
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs12: "xs12",
                                              sm12: "sm12",
                                              md12: "md12",
                                              lg12: "lg12"
                                            }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "label-resumen",
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  "text-align": "center",
                                                  "margin-top": "40px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    (_vm.sinisterCase.status.toLowerCase() ===
                                                    "aprobado"
                                                      ? "Hemos aprobado su solicitud. La información será enviada, dentro de los 2 días hábiles, al correo proporcionado"
                                                      : "Su caso ha sido respondido. Hemos enviado la información al mail registrado en la solicitud") +
                                                      ": " +
                                                      _vm.sinisterCase.email +
                                                      "."
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.caseStatus === "evaluacion" &&
                                _vm.flagEvaluationDelaying
                                  ? _c(
                                      "v-layout",
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs12: "xs12",
                                              sm12: "sm12",
                                              md12: "md12",
                                              lg12: "lg12"
                                            }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "label-resumen",
                                                staticStyle: {
                                                  "font-size": "14px",
                                                  "text-align": "center",
                                                  "margin-top": "40px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "La evaluación está tomando más tiempo de lo esperado. Por favor, espera un poco más de tiempo y te avisaremos al correo electrónico cuando tengamos una respuesta."
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              row: "row",
                              wrap: "wrap",
                              "justify-center": "justify-center"
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass:
                                  "btn-solicitud btn-pink-filled omnesSemibold",
                                staticStyle: {
                                  "margin-top": "24px",
                                  height: "50px"
                                },
                                attrs: {
                                  id: "btn-coverages",
                                  type: "button",
                                  disabled: _vm.caseId.length === 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.goToHomeFromQuery()
                                  }
                                }
                              },
                              [_vm._v("Aceptar")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-layout",
                          {
                            staticStyle: { "margin-top": "20px" },
                            attrs: {
                              row: "row",
                              wrap: "wrap",
                              "justify-center": "justify-center"
                            }
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "btn-volver",
                                on: {
                                  click: function($event) {
                                    return _vm.goBackToConsulta()
                                  }
                                }
                              },
                              [_vm._v("Volver")]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _c("loader-generic", {
        attrs: { loader: _vm.loader, textLoader: _vm.textLoader }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-principal-mobile" }, [
      _c("figure", [
        _c("figcaption", [
          _c("h1", [_vm._v("Registra y consulta tu siniestro")])
        ]),
        _c("img", {
          attrs: { src: require("../assets/img/siniestros-banner-mobile.png") }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-principal only-desktop" }, [
      _c("figure", [
        _c("figcaption", [
          _c(
            "h1",
            {
              staticStyle: {
                "font-weight": "400",
                "font-size": "44px",
                "line-height": "40px",
                "text-align": "center",
                color: "#535D66"
              }
            },
            [_vm._v("Registra y consulta tu siniestro")]
          )
        ]),
        _c("img", {
          attrs: { src: require("../assets/img/siniestros-banner.png") }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h2",
      { staticStyle: { "font-weight": "400", "text-align": "center" } },
      [
        _vm._v("Aquí podrás registrar y consultar el estado de tu  "),
        _c("strong", { staticStyle: { "font-weight": "700" } }, [
          _vm._v("Siniestro")
        ]),
        _vm._v(" de manera sencilla.")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/registrar-siniestro.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/consultar-siniestro.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title only-mobile" }, [
      _c("h2", [
        _vm._v(
          "Nosotros nos haremos cargo cuando las cosas se pongan difíciles."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "section-title only-desktop",
        staticStyle: {
          padding: "40px",
          "padding-top": "60px",
          "font-style": "normal",
          "font-weight": "600",
          "font-size": "22px !important",
          "line-height": "23px !important",
          "align-items": "center",
          "text-align": "center"
        }
      },
      [
        _c("h2", [
          _vm._v(
            "Nosotros nos haremos cargo cuando las cosas se pongan difíciles."
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-seguro-de-vida.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("../assets/img/icono-soat.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-proteccion-tarjeta.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-proteccion-financiera.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-desgravamen.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("../assets/img/icono-vida-ley.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-renta-hospitalaria.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-proteccion-tarjeta.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-proteccion-financiera.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-desgravamen.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", { attrs: { src: require("../assets/img/icono-vida-ley.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", [
      _c("img", {
        attrs: { src: require("../assets/img/icono-renta-hospitalaria.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e853be4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e853be4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LandingSiniestros.vue
// module id = null
// module chunks = 